import React, { createContext, useContext, useState } from "react";
import ImportFormWrapper from "../components/administration/data-import-export/import-form-wrapper/ImportFormWrapper";

interface IImportDataContext {
  openImportForm: (machineName: string, importId: string) => void;
  closeImportForm: () => void;
}

const ImportDataContext = createContext<IImportDataContext | undefined>(
  undefined
);

export const useImportData = () => {
  const context = useContext(ImportDataContext);
  if (!context) {
    throw new Error("useImportData must be used within ImportDataProvider");
  }
  return context;
};

export const ImportDataProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [machineName, setMachineName] = useState<string | null>(null);
  const [importId, setImportId] = useState<string | null>(null);

  const openImportForm = (machine: string, id: string) => {
    setMachineName(machine);
    setImportId(id);
    setIsOpen(true);
  };

  const closeImportForm = () => {
    setIsOpen(false);
    setMachineName(null);
    setImportId(null);
  };

  return (
    <ImportDataContext.Provider value={{ openImportForm, closeImportForm }}>
      {children}
      <ImportFormWrapper
        isOpen={isOpen}
        machineName={machineName}
        importId={importId}
        onClose={closeImportForm}
      />
    </ImportDataContext.Provider>
  );
};
